import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text, ButtonsContainer } from 'components/common/Elements/Elements';

import classes from './SelectionBar.module.scss';

interface SelectionBarProps {
  count: number;
  onCancel: () => void;
  onAssign: () => void;
}

const SelectionBar = ({ count, onCancel, onAssign }: SelectionBarProps) => {
  const { t } = useTranslation(['activity']);

  // Production gates the bar on a non-empty selection rather than rendering it
  // at zero, so the page has no permanently docked footer.
  if (count < 1) return null;

  return (
    <div className={classes.bar}>
      <div className={classes.wrap}>
        <div className={classes.counterWrap}>
          <Text className={classes.counter}>{count}</Text>
        </div>
        <Text className={classes.description}>
          {t('activity:platform.FEATURE_FLAGS_SELECTED')}
        </Text>
      </div>
      <ButtonsContainer
        counter={count}
        handleCancel={onCancel}
        handleOpenModal={onAssign}
        action="Assign"
        btnAdditional={false}
      />
    </div>
  );
};

export default SelectionBar;
